require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-186-using-teamgantt-in-the-classroom.json") })
        }
      }, "path---article-186-using-teamgantt-in-the-classroom");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-186-using-teamgantt-in-the-classroom!./.cache/json/article-186-using-teamgantt-in-the-classroom.json
// module id = 534
// module chunks = 231608221292675